module.exports = __webpack_public_path__ + "static/media/M1-16-Yazorath-Ev-cod115.1d5fd36c.png";